<div class="container">
    <h1 class="p-2 text-center">Ajout d'un paramètre de test </h1>
    <div class="row align-items-center my-2">
        <div class="col">
            <div class="col border rounded-1 p-3 background-light">

                <div class="row align-items-center">
                    <!-- <mat-form-field class="col">
                <input matInput [(ngModel)]="Model.Code" i18n-placeholder placeholder="Code" disabled="">
            </mat-form-field> -->

                    <mat-form-field class="col">
                        <mat-label>Nom du test</mat-label>
                        <input matInput [(ngModel)]="Model.Name" i18n-placeholder placeholder="Name" required>
                    </mat-form-field>

                    <mat-slide-toggle class="col mb-2" [(ngModel)]="Model.IsSum" i18n>Somme ?</mat-slide-toggle>

                    @if (Model.IsSum) {
                    <mat-form-field class="col-12">
                        <mat-select i18n-placeholder placeholder="Comparaison LQ" [(ngModel)]="Model.ComparaisonLQ">
                            @for (lq of ComparaisonLQList; track lq; let i = $index) {
                            <mat-option [value]="i + 1">
                                {{ lq }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="row align-items-center my-2">
        <div class="col">
            <div class="col border rounded-1 p-3 background-light">
                <div class="row align-items-center">

                    <h3 class="col-12 fst-italic" i18n>Unité</h3>

                    <mat-form-field class="col">
                        <mat-label>Unité du test</mat-label>
                        <input matInput [(ngModel)]="Model.ElimsUnitName" i18n-placeholder placeholder="Unité Elims" required disabled="">
                    </mat-form-field>

                    <mat-slide-toggle class="col mb-2" [(ngModel)]="NeedConversion" (change)="ConversionChanged($event)">Conversion ?</mat-slide-toggle>
                </div>
                <div class="row">

                    @if (!NeedConversion) {
                    <mat-form-field class="col-6">
                        <mat-label>Unité affiché du test</mat-label>
                        <input matInput [(ngModel)]="Model.DisplayedUnitName" i18n-placeholder placeholder="Unité affichée" required>
                    </mat-form-field>
                    }

                    @if (NeedConversion) {
                    <mat-form-field class="col-6">
                        <mat-select i18n-placeholder placeholder="Unité de conversion" [(ngModel)]="Model.DisplayedUnitName">
                            @for (u of AvailableUnitList; track u) {
                            <mat-option [value]="u">
                                {{ u }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    }

                </div>
            </div>
        </div>
    </div>
    @if (Model.ElimsTestList.length > 0) {
    <div class="col border rounded-1 p-3 background-light">
        <!-- @if (CanConvert) { -->
        <div class="row align-items-center">

            <div class="row ">
                <h3 class="col-12 fst-italic" i18n>Tests ELIMS associés  </h3>

                <mat-chip-listbox class="col-12 mt-3">
                    @for (test of Model.ElimsTestList; track test.TestCode) {
                    <mat-chip-option class="mx-1 fw-bold" color="accent" highlighted (removed)="removeElimsTest(test)">
                        {{test.TestCode}} {{test.ParameterCode}}
                        <button matChipRemove i18n-aria-label aria-label="retirer Mot-clef">
                            <mat-icon class="material-symbols-outlined">cancel</mat-icon>
                        </button>
                    </mat-chip-option>
                    }
                </mat-chip-listbox>
            </div>
        </div>
        <!-- } -->
    </div>
    }
    <div class="col border rounded-1 p-3 background-light my-3">

        <div class="row">
            <h3 class="col-12 fst-italic" i18n>Recherche de nouveaux tests </h3>

            <div class="col">
                <mat-form-field class="w-100">
                    <mat-label i18n>Mot-clef validé en appuyant sur entrée</mat-label>
                    <mat-chip-grid #chipGrid i18n-aria-label aria-label="Mot-clef" [formControl]="formControl">
                        @for (keyword of keywords; track keyword) {
                        <mat-chip-row color="primary" highlighted (removed)="removeKeyword(keyword)">
                            {{keyword}}
                            <button matChipRemove i18n-aria-label aria-label="retirer Mot-clef">
                                <mat-icon class="material-symbols-outlined">cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                        }
                        <input i18n-placeholder placeholder="Nouveau Mot-clef..." [matChipInputFor]="chipGrid" (matChipInputTokenEnd)="add($event)" />
                    </mat-chip-grid>
                </mat-form-field>
            </div>
            <div class="col-auto">
                <mat-slide-toggle class="my-3" [(ngModel)]="IsStrictSearch" i18n>Strict</mat-slide-toggle>
            </div>
            <div class="col-auto">
                <button appPreventDoubleClick class="col me-1 h-75" color="basic" mat-stroked-button (throttledClick)="search()" i18n>
                    Chercher
                </button>
            </div>
        </div>

        <div class="row">
            <!--  [style.overflow]="'auto'"  [style.max-height.px]="'400'" -->
            <mat-selection-list #t (selectionChange)="onSelection($event, t.selectedOptions)">
                @for (test of AvailableElimsTestList; track test; let i = $index) {
                <mat-list-option [value]="test"
                                 [style.background]="i % 2 === 0  ? 'white' : 'orange'">
                    <div class="row">
                        <div class="col text-truncate"><span class="fw-bold">{{test.TestCode}}</span> {{test.TestName}} </div>
                        <div class="col-auto">[{{test.ElimsUnitName}}]</div>
                    </div>

                    <div class="col-12"><span class="fw-bold">{{test.ParameterCode}}</span> {{test.ParameterName}}</div>
                </mat-list-option>
                }
            </mat-selection-list>
        </div>
    </div>
    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="goBack()" i18n>
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1 white" color="accent" mat-raised-button (throttledClick)="onConfirm()"
                [disabled]="!CanSave()" i18n>
            {{ IsCreation ? 'Ajouter' : 'Modifier' }}
        </button>
    </div>
</div>